import { useEffect } from 'react';
import { Id, ToastOptions, toast } from 'react-toastify';
import { Error } from '../types/error';

const useToastError = (error: Error, toastOptions?: Partial<ToastOptions>) => {
  useEffect(() => {
    let toastId: Id;
    if (!error?.message) {
      return;
    }
    toastId = toast.error(error.message, {
      position: 'bottom-right',
      autoClose: false,
      pauseOnFocusLoss: true,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      ...(toastOptions ?? {}),
    });
    return () => {
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [error]);
};

export { useToastError };
